import type { ReactNode } from "react";

export function Badge({ tone = "neutral", children }: { tone?: "neutral" | "good" | "warn" | "danger" | "violet"; children: ReactNode }) {
  const tones = {
    neutral: "border-slate-600/60 bg-slate-800/80 text-slate-200",
    good: "border-mint/40 bg-mint/12 text-mint",
    warn: "border-amber/40 bg-amber/12 text-amber",
    danger: "border-danger/40 bg-danger/12 text-danger",
    violet: "border-violet/40 bg-violet/15 text-violet-100"
  };
  return <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold ${tones[tone]}`}>{children}</span>;
}
